import { createSlice } from '@reduxjs/toolkit';
import {
  COUPON_EMAIL_SEND_SIGNUP_MODAL,
  COUPON_TEXT_SEND_SIGNUP_MODAL,
  FREE_COUPON_MODAL,
  GLP_SIGNUP_MODAL,
  HAMBURGER_MENU_MODAL,
  HOMEPAGE_MID_SIGNUP_MODAL,
  LOYALTY_SIGNUP_MODAL,
  NAVBAR_SIGNUP_MODAL,
  PHARMACY_PRICE_LIST_MODAL,
  SIGNUP_PAGE_SIGNUP_MODAL,
  SOFT_COUPON_MODAL
} from '../constants/defaults';

const initialState = { modal: '', item: {} };

const modalSlice = createSlice({
  name: 'modal',
  initialState: initialState,
  reducers: {
    freeCouponModal(state, action) {
      state.modal = FREE_COUPON_MODAL;
      state.item = action.payload.item;
    },
    loyaltySignupModal(state) {
      state.modal = LOYALTY_SIGNUP_MODAL;
    },
    navBarSignupModal(state) {
      state.modal = NAVBAR_SIGNUP_MODAL;
    },
    homepageMidSignupModal(state) {
      state.modal = HOMEPAGE_MID_SIGNUP_MODAL;
    },
    glpSignupModal(state) {
      state.modal = GLP_SIGNUP_MODAL;
    },
    signupPageSignupModal(state) {
      state.modal = SIGNUP_PAGE_SIGNUP_MODAL;
    },
    couponTextSentSignupModal(state) {
      state.modal = COUPON_TEXT_SEND_SIGNUP_MODAL;
    },
    couponEmailSentSignupModal(state) {
      state.modal = COUPON_EMAIL_SEND_SIGNUP_MODAL;
    },
    priceListSignupModal(state) {
      state.modal = PHARMACY_PRICE_LIST_MODAL;
    },
    softCouponModal(state) {
      state.modal = SOFT_COUPON_MODAL;
    },
    hamburgerMenuModal(state) {
      state.modal = HAMBURGER_MENU_MODAL;
    },
    clearModal(state) {
      state.modal = '';
      state.item = {};
    }
  }
});

export const modalActions = modalSlice.actions;

export default modalSlice;
